import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Bot } from "lucide-react";
import { AskPanel } from "@/features/network/AskPanel";
import { useAskDrawer } from "../askDrawer";
import s from "./layout.module.css";

/**
 * The assistant lives in a drawer over whatever page is open, reached from a round button in the bottom right.
 * On a person's page the button asks about that person; "Ask Hub about ..." on the card opens the same drawer.
 */
export function AskDrawer() {
  const { open, contactId, openAsk, closeAsk } = useAskDrawer();
  const location = useLocation();
  const onAskPage = location.pathname.startsWith("/ask");
  // Messages has its own composer in that corner; Ask stays in the sidebar there.
  const onMessages = location.pathname.startsWith("/messages");
  const pageContact = /^\/contact\/([^/]+)/.exec(location.pathname)?.[1] ?? null;

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeAsk();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, closeAsk]);

  if (onAskPage) return null;
  return (
    <>
      {!open && !onMessages && (
        <button type="button" className={s.askFab} onClick={() => openAsk(pageContact && pageContact !== "new" ? pageContact : null)} title={pageContact ? "Ask Hub about this person" : "Ask Hub anything about your network"} aria-label="Ask Hub" data-testid="ask-fab">
          <Bot size={18} />
          <span>Ask Hub</span>
        </button>
      )}
      {open && (
        <>
          <div className={s.askScrim} onClick={closeAsk} aria-hidden />
          <aside className={s.askDrawer} aria-label="Ask Hub" data-testid="ask-drawer">
            <AskPanel key={contactId ?? "none"} contactId={contactId ?? undefined} onClose={closeAsk} />
          </aside>
        </>
      )}
    </>
  );
}
